export enum PlaybackState {
    UNSTARTED,
    PLAYING,
    PAUSED,
    BUFFERING
}